import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-solid-svg-icons";

export default function DeleteActiveTableRow({ deleteRow, data }) {
  const [deleting, setDeleting] = useState(false);

  return (
    <FontAwesomeIcon
      className={!deleting ? "clickable" : undefined}
      size="1x"
      icon={faTrash}
      title="Delete Row"
      onClick={!deleting && onClick}
    />
  );

  function onClick() {
    const needsConfirmation = !!data.uuid;

    const confirmed =
      !needsConfirmation ||
      window.confirm("Are you sure you would like to delete this row?");

    if (!confirmed) {
      return;
    }
    setDeleting(true);
    deleteRow(data.uniqueRowUuid);
  }
}
